// VoiceFabric Trace card — master-admin-only embed on the call detail page.
import React from 'react';
import { Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { VoiceFabricTrace } from '../../components/voicefabric/VoiceFabricTrace';

export const VoiceFabricTraceCard = ({ callId, token, onOpenFullPage }) => (
  <Card className="bg-[#0D1526] border-white/10">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-white">
        <Zap className="w-5 h-5 text-yellow-400" />
        VoiceFabric Trace
        <button
          onClick={onOpenFullPage}
          className="ml-auto text-xs font-normal text-teal-400 hover:text-teal-300"
          data-testid="open-voicefabric-trace-page"
        >
          Open full page →
        </button>
      </CardTitle>
      <CardDescription className="text-white/40">
        Rules that ran on this call, what was extracted, and where it was dispatched.
      </CardDescription>
    </CardHeader>
    <CardContent>
      <VoiceFabricTrace callId={callId} token={token} compact />
    </CardContent>
  </Card>
);
